import { get } from 'lodash'
import { graphql } from 'gatsby'
import React from 'react'

import { Base, Footer, Navigation } from 'components/common'
import ContactPageTemplate from 'templates/contact-page'

const getNode = obj => get(obj, 'edges.0.node', {})

export default function AboutPage({ data = {} }) {
  const { frontmatter: globals } = getNode(data.globals)
  const { frontmatter: content } = getNode(data.contact)

  const {
    accreditations,
    footer,
    navigation,
  } = globals

  const {
    heroImage,
    heroHeading,
    heroSubheading,
  } = content

  const { phoneNumber } = footer

  return (
    <Base>
      <Navigation {...navigation} phoneNumber={phoneNumber} />
      <ContactPageTemplate
        accreditations={accreditations}
        heroImage={heroImage}
        heroHeading={heroHeading}
        heroSubheading={heroSubheading}
        showContactForm
      />
      <Footer {...footer} />
    </Base>
  )
}

export const pageQuery = graphql`
query ContactPageQuery {
  globals: allMarkdownRemark(
    filter: { frontmatter: { templateKey: { eq: "globals" } }}
  ) {
    edges {
      node {
        frontmatter {
          accreditations {
            alt
            image {
              childImageSharp {
                fluid(maxWidth: 400, quality: 80) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
          footer {
            logo {
              childImageSharp {
                fluid(maxWidth: 400, quality: 80) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            emailAddress
            phoneNumber
          }
          navigation {
            logo {
              alternativeText
              image {
                childImageSharp {
                  fluid(maxWidth: 400, quality: 100) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
            pages {
              label
              path
            }
          }
        }
      }
    }
  }

  contact: allMarkdownRemark(
    filter: { frontmatter: { templateKey: { eq: "contact-page" } }}
  ) {
    edges {
      node {
        html
        frontmatter {
          heroHeading
          heroImage {
            childImageSharp {
              fluid(maxWidth: 1200, quality: 80) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          heroSubheading
          testimonial {
            author
            quote
          }
        }
      }
    }
  }
}
`
